
<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<div class="do-not-print" *ngIf="showCountReport">
    <div class="row">
        <div class="col-24">
            <h2 class="head2-small no-margin">Enrollments</h2>
        </div>
    </div>
    <div *ngIf="isSummary" class="row">
        <div class="col-24">
            <button id="btnBack" class="button primary" (click)="onGetTemporaryIDCard()">Temporary Member ID Card</button>
        </div>
    </div>
    <div class="row">
        <div class="col-24">
            <button *ngIf="isSummary" id="btnBack" class="button cancel" (click)="onBack()">Back</button>
        </div>
    </div>
    <br />
    <div class="row" *ngIf="this.isOrgPresent">
        <div class="col-24">
            <div class="alert danger">
                <ul>
                    <li><button>We’re sorry, but that user doesn’t appear to be associated with your organization.</button></li>
                </ul>
            </div>
        </div>
    </div>
   
    <div class="row" *ngIf="!this.isOrgPresent">
        <div class="col-2">
            <a id="btnPrint" class="link-button link print" (click)="onPrint()">Print</a>
        </div>
        <div class="col-8">
            <button id="btnExport" class="button link excel" (click)="onExport()">Export to Excel</button>
        </div>
    </div>
    <div class="row" id="printArea" *ngIf="!this.isOrgPresent">
        <div class="col-24">
            <p>Click an underlined item to see more detail.</p>
            <jqxGrid [width]="1240"
                     [source]="dataAdapter"
                     [columns]="columns"
                     [autorowheight]="true"
                     [autoshowcolumnsmenubutton]="false"
                     [autoheight]="true"
                     [pageable]="true"
                     [pagesizeoptions]="[20, 50, 100]"
                     [pagesize]="50"
                     [sortable]="true"
                     [columnsresize]="true"
                     [selectionmode]="'multiplecellsadvanced'"
                     [showaggregates]="true"
                     (onPagesizechanged)="onPageSizeChanged($event)"
                     (onCellclick)="Cellclick($event)"
                     #TreeGrid>
            </jqxGrid>
        </div>
    </div>
    <button #reportStart class="focusable-element"></button>
</div>
